export enum ApplicationPaths {
  REVIEWS = "reviews",
  // REPORTS = "reports",
  ANSWERS = "answers",
}
